import { Link } from "react-router-dom";
import { Github, Linkedin, Sparkles, Twitter } from "lucide-react";

const COLS = [
  {
    title: "Product",
    links: [
      { label: "Boardroom", to: "/boardroom" },
      { label: "Agents", to: "/agents" },
      { label: "Tasks", to: "/tasks" },
      { label: "Roadmap", to: "/roadmap" },
      { label: "Vault", to: "/vault" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/" },
      { label: "Careers", to: "/" },
      { label: "Press", to: "/" },
      { label: "Contact", to: "/" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/" },
      { label: "Docs", to: "/" },
      { label: "Changelog", to: "/" },
      { label: "Status", to: "/" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", to: "/" },
      { label: "Terms", to: "/" },
      { label: "Security", to: "/" },
      { label: "DPA", to: "/" },
    ],
  },
];

export default function LandingFooter() {
  return (
    <footer
      data-testid="landing-footer"
      className="relative overflow-hidden bg-[#0B0B0E] text-white"
    >
      {/* Watermark */}
      <div
        aria-hidden
        data-testid="footer-watermark"
        className="pointer-events-none absolute -bottom-8 left-1/2 -translate-x-1/2 select-none text-[180px] font-black leading-none tracking-[-0.04em] text-white/[0.06] md:text-[260px] xl:text-[320px]"
      >
        Idea AI
      </div>

      <div className="relative mx-auto max-w-7xl px-5 pb-16 pt-20 md:px-8 md:pt-28">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white text-zinc-900">
                <Sparkles className="h-4 w-4" strokeWidth={2.4} />
              </div>
              <span className="text-[15px] font-extrabold tracking-tight">
                Idea AI
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-[12.5px] leading-relaxed text-zinc-400">
              The AI exec team for solo founders. Eight agents. Endless leverage.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.title} data-testid={`footer-col-${col.title.toLowerCase()}`}>
              <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-zinc-400">
                {col.title}
              </div>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-[13px] text-zinc-300 transition-colors hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center">
          <div className="text-[12px] text-zinc-500">
            © 2026 Idea AI, Inc. All rights reserved.
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-twitter"
              className="flex h-8 w-8 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:bg-white/10 hover:text-white"
              aria-label="Twitter"
            >
              <Twitter className="h-3.5 w-3.5" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-linkedin"
              className="flex h-8 w-8 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:bg-white/10 hover:text-white"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-3.5 w-3.5" />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-social-github"
              className="flex h-8 w-8 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:bg-white/10 hover:text-white"
              aria-label="GitHub"
            >
              <Github className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
